import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display a country field in the charge list
 * Uses the embedded country object from the charge API response
 */
const ChargeCountryField: React.FC<FieldProps<any>> = ({
    record,
    link = false,
}) => {
    if (!record) return null;

    // Handle both nested country object and direct countryId
    const country = record.country;
    const countryId = country?.id || record.countryId;
    const countryName = country?.name;

    if (!countryId) return <span>-</span>;
    if (!countryName) return <span>{countryId}</span>;

    return link ? (
        <Link to={`/country/${countryId}/show`}>{countryName}</Link>
    ) : (
        <span>{countryName}</span>
    );
};

ChargeCountryField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

ChargeCountryField.defaultProps = {
    addLabel: true,
    label: 'Country',
};

export default ChargeCountryField;
